import React, { useState, useContext, useEffect, useRef } from 'react';
import Select from 'react-select';
import { AppContext } from '../../../../providers/appProvider';
import { selectStyle } from './selectStyle';

const MarineLine = ({ defaultCar, carService }) => {
    const [car, setCar] = useState(defaultCar);
    const { appState } = useContext(AppContext);

    const [selectedOption, setSelectedOption] = useState(car?.marine_line?.id ?? null);
    const [showDropdownMarineLine, setShowDropdownMarineLine] = useState(null);
    const dropdownMarineLineRef = useRef(null);

    const options = appState.marines.map((marine) => ({
        value: marine.id,
        label: marine.name,
    }));

    useEffect(() => {
        if (defaultCar?.marine_line?.id) {
            setSelectedOption(defaultCar.marine_line.id);
        }
    }, [defaultCar]);

    const onChangeMarine = (selectedOption) => {
        const MarineN = Number(selectedOption.value);
    
        carService.updateMarine(car.id, MarineN)
            .then(() => {
                // განახლებული car ობიექტის შექმნა
                setCar((prevCar) => ({
                    ...prevCar,
                    marine_line: {
                        id: MarineN,
                        name: options.find((option) => option.value === MarineN)?.label || '',
                    },
                }));
    
                // ახალი მონაცემების ჩამოტვირთვა (თუ საჭირო არის)
                carService.fetchCars();
            })
            .catch((error) => {
                console.error(error);
            });
    };
    

    const toggleMarineLine = (containerId) => {
        setShowDropdownMarineLine((prev) => (prev === containerId ? null : containerId));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownMarineLineRef.current &&
                !dropdownMarineLineRef.current.contains(event.target)
            ) {
                setShowDropdownMarineLine(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            {showDropdownMarineLine === car.id ? (
                <div ref={dropdownMarineLineRef}>
                    <Select
                        styles={selectStyle}
                        isSearchable={true}
                        onChange={onChangeMarine}
                        value={options.find((option) => option.value === selectedOption) || null}
                        options={options}
                    />
                </div>
            ) : (
                <div
                    role="button"
                    tabIndex={0}
                    aria-expanded={showDropdownMarineLine === car.id}
                    onClick={() => toggleMarineLine(car.id)}
                >
                    {car.marine_line?.name || '- - -'}   
                </div>
            )}
        </>
    );
};

export default MarineLine;
